import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import {
  ComponentNotificationTitleAssigned,
  isUserType,
} from "./types/task-notification.types";
import { getTitleAssignerString } from "./utils/task-notification-title";
import styles from "./task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationTitleAssignedProps extends ComponentNotificationTitleAssigned {
  read: boolean;
}
export const TaskNotificationTitleAssigned = ({
  props: { assignedBy, assignedTo },
  read,
}: TaskNotificationTitleAssignedProps) => {
  const { t } = useTranslation();
  const assignedByString = getTitleAssignerString(assignedBy);
  const assignedToString = isUserType(assignedTo)
    ? getTitleAssignerString(assignedTo)
    : assignedTo.name;
  return (
    <div className={styles["task-notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      {isUserType(assignedTo)
        ? t("hasAssignedTaskToYouString", { assigner: assignedByString })
        : t("hasAssignedTaskToTeamString", {
            assigner: assignedByString,
            team: assignedToString,
          })}
    </div>
  );
};
